import React from 'react';

const thumbnailUrl = (url = '') => {
  const urlParts = url.split('/');
  urlParts[urlParts.length - 1] = urlParts[urlParts.length - 1].replace(
    /^_hd_product/,
    '_hd_thm_product'
  );
  return urlParts.join('/');
};

const ThemeAndProductImages = ({
  selectedTheme = {},
  product = {},
  selectedVariant
}) => {
  const {
    theme_and_product_images: productImages = [],
    theme_images_display_position: themeImagesDisplayPosition = ''
  } = product;

  const variants = selectedTheme.variants || {};
  const variant = variants[selectedVariant] || Object.values(variants).find(v => v.default) || {};

  const variantImages =
    variant.images ||
    (selectedTheme.variant_thumbs && selectedTheme.variant_thumbs[selectedVariant]) ||
    selectedTheme.default_variant?.thumbs ||
    selectedTheme.thumbs ||
    [];

  const variantVideos =
    variant.videos ||
    (selectedTheme.variant_videos && selectedTheme.variant_videos[selectedVariant]) ||
    selectedTheme.default_variant?.videos ||
    selectedTheme.videos ||
    [];

  const themeVideos = (variantVideos || []).map(video => ({
    url: video,
    thumbnail: '/images/play-video.png',
    type: 'video'
  }));

  const themeImages = (variantImages || []).map((image, i) => ({
    url: image,
    thumbnail: (variant.thumbnails && variant.thumbnails[i]) || thumbnailUrl(image),
    type: 'image'
  }));

  switch (themeImagesDisplayPosition.toLowerCase()) {
    case 'above':
      return [...themeVideos, ...themeImages, ...productImages];
    case 'below':
      return [...productImages, ...themeVideos, ...themeImages];
    default:
      return productImages;
  }
};

export default ThemeAndProductImages;